import * as React from 'react';
import * as R from 'ramda';
import { SecondaryReportOrgUserForm, SurveyReportTypeUserForm } from '../../components';
import { Form, Text, Select, FormState, FormValues, FormErrors, Checkbox, FormApi } from 'react-form';
import { BaseFormProps, BaseFormState } from '../../interfaces';
import { Organization, Language, TeamTypeahead, UserTypeahead, EnumEntry, OrganizationTypeahead, UserTeam, Survey, SecondaryReportOrgUser } from '../../models';
import { TypeaheadService, ValidationService, NotificationService, UserDataService, SurveyDataService, SecondaryReportDataService } from '../../services';
import { InputGroup } from 'react-bootstrap';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import { EnumStore, FilterStore, UserStore } from '../../stores';
import { inject } from 'mobx-react';
import { computed } from 'mobx';
import { ChangeEvent } from 'react';
import { PonderaModal } from '..';
import { UserSort } from '../../utilities';

interface FormProps extends BaseFormProps {
    organizations: Organization[];
    languages: Language[];
    notificationService: NotificationService;
    EnumStore?: EnumStore;
    FilterStore?: FilterStore;
    UserStore?: UserStore;
}

interface UserFormState extends BaseFormState {
    userRoleOptions: { label: string, value: any }[];
    userPermissionsOptions: { label: string, value: any, isChecked: boolean }[];
    selectedOrganizationId?: number;
    isPonderaAssociate: boolean;
    selectedTeams?: TeamTypeahead[];
    confirmedTeams: UserTeam[];
    selectedOrgs?: any[];
    confirmedOrgs: any[];
    confirmedManager?: UserTypeahead;
    teamTypeahead: {
        allowNew: boolean;
        isLoading: boolean;
        multiple: boolean;
        options: any[];
    };
    orgTypeahead: {
        allowNew: boolean;
        isLoading: boolean;
        multiple: boolean;
        options: any[];
    };
    managerTypeahead: {
        allowNew: boolean;
        isLoading: boolean;
        multiple: boolean;
        options: any[];
    };
    userRoleHelpModalVisible: boolean;
    userRoleHelpModalContent: string;
    emailValidating: boolean;
    surveys: Survey[];
    selectedSurveyId: number;
    selectedSurveyVersionId: number;
    selectedSecondaryReportId: number;
    secondaryReportUserOrgs: SecondaryReportOrgUser[];
}

@inject('EnumStore', 'FilterStore', 'UserStore')
export class UserForm extends React.Component<FormProps, UserFormState> {
    private vs = new ValidationService();
    private userService = new UserDataService(this.props.notificationService);
    private surveyService = new SurveyDataService(this.props.notificationService);
    private typeaheadService = new TypeaheadService(this.props.notificationService);
    private secondaryReportDataService = new SecondaryReportDataService(this.props.notificationService);
    private teamTypeahead: any;
    private orgTypeahead: any;
    private formApi: FormApi;

    @computed get userRole() {
        return this.props.UserStore!.userInfo.userRole;
    }

    constructor(props: FormProps) {
        super(props);

        let userRoleModalContent = `<dl class="dl-horizontal">`;

        const userRoleOptions = this.props.EnumStore!.userRoles.map((item: EnumEntry) => {
            userRoleModalContent = `${userRoleModalContent}<dt>${item.name}</dt><dd>${item.description}</dd>`;

            return {
                label: item.name,
                value: item.value
            };
        });

        userRoleModalContent = `${userRoleModalContent}</dl>`;

        const userPermissions = this.props.EnumStore!.userPermissions.map((item: EnumEntry) => {
            let isChecked = false;

            if (this.props.defaultValues && this.props.defaultValues.userPermissions) {
                var permissionExists = this.props.defaultValues.userPermissions.find((x: any) => x === item.value);

                if (permissionExists) { isChecked = true; }
            }

            return {
                label: item.name,
                value: item.value,
                isChecked: isChecked
            };
        });

        let isPonderaAssociate = false;
        if (this.props.defaultValues && this.props.defaultValues!.userRole === 'ponderaAssociate') {
            isPonderaAssociate = true;
        }

        this.state = {
            userRoleOptions: userRoleOptions,
            userPermissionsOptions: userPermissions,
            confirmedTeams: [],
            teamTypeahead: {
                allowNew: false,
                isLoading: false,
                multiple: true,
                options: [],
            },
            confirmedOrgs: [],
            orgTypeahead: {
                allowNew: false,
                isLoading: false,
                multiple: true,
                options: [],
            },
            managerTypeahead: {
                allowNew: false,
                isLoading: false,
                multiple: false,
                options: [],
            },
            canSubmit: false,
            formErrors: {},
            isPonderaAssociate: isPonderaAssociate,
            userRoleHelpModalVisible: false,
            userRoleHelpModalContent: userRoleModalContent,
            emailValidating: false,
            surveys: [],
            selectedSurveyId: -1,
            selectedSurveyVersionId: -1,
            selectedSecondaryReportId: -1,
            secondaryReportUserOrgs: []
        };

        if (this.props.defaultValues) {
            if (this.filteredOrganization) {
                this.props.defaultValues.organizationID = this.props.defaultValues.organizationID || this.filteredOrganization.id;
            }
            if (this.props.languages && this.props.languages.length > 0) {
                this.props.defaultValues.languageID = this.props.defaultValues.languageID || this.props.languages[0].id;
            }

            this.props.defaultValues.userRole = this.props.defaultValues.userRole || 'user';
        }

        this.handleTeamSearch = this.handleTeamSearch.bind(this);
        this.handleManagerSearch = this.handleManagerSearch.bind(this);
        this.formDidUpdate = this.formDidUpdate.bind(this);
        this.addTeam = this.addTeam.bind(this);
        this.removeTeamBinder = this.removeTeamBinder.bind(this);
        this.teamTypeaheadOnChange = this.teamTypeaheadOnChange.bind(this);
        this.managerTypeaheadOnChange = this.managerTypeaheadOnChange.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.permissionCheckboxUpdatedBinder = this.permissionCheckboxUpdatedBinder.bind(this);
        this.handleOrganizationSearch = this.handleOrganizationSearch.bind(this);
        this.orgTypeaheadOnChange = this.orgTypeaheadOnChange.bind(this);
        this.addOrg = this.addOrg.bind(this);
        this.removeOrgBinder = this.removeOrgBinder.bind(this);
        this.hideUserRoleModal = this.hideUserRoleModal.bind(this);
        this.showUserRoleModal = this.showUserRoleModal.bind(this);

        this.validateErrors = this.validateErrors.bind(this);
        this.validateSuccess = this.validateSuccess.bind(this);
    }

    @computed get filteredOrganization() {
        return this.props.FilterStore!.organization;
    }

    private handleOrganizationSearch(filter: string) {
        const { orgTypeahead, confirmedOrgs } = this.state;
        this.setState({ orgTypeahead: Object.assign({}, orgTypeahead, { isLoading: true }) });

        this.typeaheadService.getOrganizations(filter)
            .then((response: OrganizationTypeahead[]) => {
                const potentialOrgs = response.filter((org) => !confirmedOrgs.some(x => x.id === org.id));
                this.setState({
                    orgTypeahead: Object.assign(
                        {},
                        orgTypeahead,
                        {
                            isLoading: false,
                            options: potentialOrgs
                        }
                    )
                });
            });
    }

    private handleOrgOnFocus = (e: Event): any => {
        this.handleOrganizationSearch('');
    }

    private handleTeamSearch(filter: string) {
        const { selectedOrganizationId, teamTypeahead, confirmedTeams } = this.state;
        if (selectedOrganizationId) {
            this.setState({ teamTypeahead: Object.assign({}, teamTypeahead, { isLoading: true }) });

            this.typeaheadService.getTeamTypeaheadsByOrganization(selectedOrganizationId, filter)
                .then((response: TeamTypeahead[]) => {
                    var potentialTeams = response;
                    if (confirmedTeams) {
                        potentialTeams = response.filter((team) => 
                        !confirmedTeams.some(x => x.team!.id === team.id));
                    }

                    this.setState({
                        teamTypeahead: Object.assign(
                            {},
                            teamTypeahead,
                            {
                                isLoading: false,
                                options: potentialTeams
                            }
                        )
                    });
                });
        }
    }

    private handleTeamOnFocus = (e: Event): any => {
        this.handleTeamSearch('');
    }

    private handleManagerSearch(filter: string) {
        const { selectedOrganizationId, managerTypeahead, confirmedManager } = this.state;
        if (selectedOrganizationId) {
            this.setState({ managerTypeahead: Object.assign({}, managerTypeahead, { isLoading: true }) });

            this.typeaheadService.getUserTypeaheadsByOrganization(selectedOrganizationId, filter)
                .then((response: UserTypeahead[]) => {
                    const potentialManagers = response.filter((user) => {
                        if (confirmedManager) {
                            return confirmedManager.id !== user.id;
                        }

                        return true;
                    });

                    this.setState({
                        managerTypeahead: Object.assign(
                            {},
                            managerTypeahead,
                            {
                                isLoading: false,
                                options: potentialManagers.sort(UserSort)
                            }
                        )
                    });
                });
        }
    }

    private handleManagerOnFocus = (e: Event): any => {
        this.handleManagerSearch('');
    }

    componentDidMount() {
        if (this.props.defaultValues) {
            this.setState({
                selectedOrganizationId: this.props.defaultValues.organizationID,
                confirmedTeams: this.props.defaultValues.teams || [],
                confirmedOrgs: this.props.defaultValues.associateOrganizations || [],
                confirmedManager: this.props.defaultValues.manager
            });

            if (this.userRole === 'superAdmin' || this.userRole === 'siteAdmin') {
                this.surveyService.getAllForSecondaryReports(this.props.defaultValues.organizationID).then((surveys: Survey[]) => {
                    this.setState({
                        surveys: surveys
                    });
                });

                this.secondaryReportDataService.getAllForUser(this.props.defaultValues.id).then((srou: SecondaryReportOrgUser[]) => {
                    this.setState({
                        secondaryReportUserOrgs: srou
                    });
                });
            }
        }
    }

    private formDidUpdate(formState: FormState) {
        if (formState.values) {
            if (formState.values.organizationID !== this.state.selectedOrganizationId) {
                this.setState({ selectedOrganizationId: formState.values.organizationID });
            }

            if (formState.values.userRole === 'ponderaAssociate') {
                this.setState({ isPonderaAssociate: true });
            } else {
                this.setState({ isPonderaAssociate: false });
            }
        }
    }

    private teamTypeaheadOnChange(selected: Array<Object | String>) {
        this.setState({ selectedTeams: selected as TeamTypeahead[] });
    }

    private orgTypeaheadOnChange(selected: Array<Object | String>) {
        this.setState({ selectedOrgs: selected });
    }

    private managerTypeaheadOnChange(selected: Array<Object | String>) {
        if (selected.length > 0) {
            this.setState({ confirmedManager: selected[0] as UserTypeahead });
        }
    }

    private addTeam(e: any) {
        e.preventDefault();
        const { selectedTeams, confirmedTeams } = this.state;

        if (selectedTeams && selectedTeams.length > 0) {
            const newTeams = selectedTeams.filter(team => {
                return !confirmedTeams.some(x => x.teamID === team.id);
            });

            const userTeams: UserTeam[] = newTeams.map(team => {
                return {
                    team: team,
                    teamID: team.id,
                    isManager: false,
                    isMember: true
                };
            });

            this.setState({
                confirmedTeams: [...confirmedTeams, ...userTeams],
                selectedTeams: []
            });

            this.teamTypeahead.getInstance().clear();
        }
    }

    private removeTeam(teamId: number) {
        const { confirmedTeams } = this.state;

        this.setState({ confirmedTeams: confirmedTeams.filter((x: UserTeam) => x.teamID !== teamId) });
    }

    private removeTeamBinder(id: number): ((event: React.MouseEvent<HTMLElement>) => void) {

        return this.removeTeam.bind(this, id);
    }

    private handleIsMemberChange(teamId: number) {
        const { confirmedTeams } = this.state;

        const teamMembers = confirmedTeams.map((x: UserTeam) => {
            if (x.teamID !== teamId) {
                return x;
            }

            x.isMember = !x.isMember;
            return x;
        });

        this.setState({ confirmedTeams: teamMembers });
    }

    private handleIsMemberChangeBinder(id: number): any {
        return this.handleIsMemberChange.bind(this, id);
    }

    private handleIsManagerChange(teamId: number) {
        const { confirmedTeams } = this.state;

        const teamMembers = confirmedTeams.map((x: UserTeam) => {
            if (x.teamID !== teamId) {
                return x;
            }

            x.isManager = !x.isManager;
            return x;
        });

        this.setState({ confirmedTeams: teamMembers });
    }

    private handleIsManagerChangeBinder(id: number): any {
        return this.handleIsManagerChange.bind(this, id);
    }

    private addOrg(e: any) {
        e.preventDefault();
        const { selectedOrgs, confirmedOrgs } = this.state;

        if (selectedOrgs && selectedOrgs.length > 0) {
            if (confirmedOrgs.length === 0) {
                this.setState({ confirmedOrgs: selectedOrgs });
            }

            const newOrgs = selectedOrgs.filter(org => {
                return !confirmedOrgs.some(x => x.id === org.id);
            });

            this.setState({
                confirmedOrgs: [...confirmedOrgs, ...newOrgs],
                selectedOrgs: []
            });

            this.orgTypeahead.getInstance().clear();
        }
    }

    private removeOrg(orgId: number) {
        const { confirmedOrgs } = this.state;

        this.setState({ confirmedOrgs: confirmedOrgs.filter((x: OrganizationTypeahead) => x.id !== orgId) });
    }

    private removeOrgBinder(id: number): ((event: React.MouseEvent<HTMLElement>) => void) {

        return this.removeOrg.bind(this, id);
    }

    private handleFormSubmit(values: any) {
        values.teams = this.state.confirmedTeams;

        // if (values.userRole === 'ponderaAssociate') {
        values.associateOrganizations = this.state.confirmedOrgs;
        // } else {
        //     values.associateOrganizations = [];
        // }

        values.userPermissions = this.state.userPermissionsOptions.filter(x => x.isChecked).map(x => x.value);

        if (this.state.confirmedManager) {
            values.managerID = this.state.confirmedManager.id;
        }

        this.props.submit(values);
    }

    private permissionCheckboxUpdated(permission: string) {
        let newPermissions = [...this.state.userPermissionsOptions];

        const userPermissionIndex = newPermissions.findIndex(x => x.value === permission);

        if (userPermissionIndex >= 0) {
            newPermissions[userPermissionIndex].isChecked = !newPermissions[userPermissionIndex].isChecked;

            this.setState({
                userPermissionsOptions: newPermissions
            });
        }
    }

    private permissionCheckboxUpdatedBinder(permission: string): ((event: ChangeEvent<HTMLInputElement>) => void) {
        return this.permissionCheckboxUpdated.bind(this, permission);
    }

    private hideUserRoleModal() {
        this.setState({ userRoleHelpModalVisible: false });
    }

    private showUserRoleModal() {
        this.setState({ userRoleHelpModalVisible: true });
    }

    // Validation methods
    validateErrors(values: FormValues) {
        const { firstName, lastName, languageID, organizationID } = values;
        let formErrors: any = {};

        if (firstName || firstName === '') {
            if (!this.vs.required(firstName)) {
                formErrors.firstName = 'First name is required.';
            } else if (!this.vs.cannotBeEmpty(firstName!)) {
                formErrors.firstName = 'First name cannot be blank.';
            }
        }

        if (lastName || lastName === '') {
            if (!this.vs.required(lastName)) {
                formErrors.lastName = 'Last name is required.';
            } else if (!this.vs.cannotBeEmpty(lastName!)) {
                formErrors.lastName = 'Last name cannot be blank.';
            }
        }

        const existingEmailError = this.state.formErrors.email;
        if (existingEmailError != null) {
            formErrors.email = existingEmailError;
        }

        if (languageID) {
            if (!this.vs.required(languageID)) {
                formErrors.languageID = 'Language is required.';
            }
        }

        if (organizationID) {
            if (!this.vs.required(organizationID)) {
                formErrors.organizationID = 'Organization is required.';
            }
        }

        return formErrors;
    }

    validateSuccess(values: FormValues, errors: FormErrors) {
        const { emailValidating } = this.state;
        // make sure we have no errors and all the required values
        if (R.isEmpty(errors)
            && !emailValidating
            && this.vs.validateRequiredFieldsExist(['firstName', 'lastName', 'email', 'languageID', 'userRole', 'organizationID'], values)
        ) {
            this.setState({ canSubmit: true, formErrors: errors });
        } else {
            this.setState({ canSubmit: false, formErrors: errors });
        }

        return errors;
    }

    setFormApi = (api: FormApi) => {
        this.formApi = api;
    }

    checkEmailAddress = (e: any) => {
        const email = this.formApi.getFormState().values.email;

        if (!email || email === '') {
            this.setState({ formErrors: Object.assign({ ...this.state.formErrors }, { email: 'Email is required' }) }, () => { this.formApi.setTouched('email', true); });
        } else if (!e.target.validity.valid) {
            this.setState({
                formErrors: Object.assign({ ...this.state.formErrors }, { email: 'Invalid Email format' })
            });
        } else {
            this.setState({ emailValidating: true });

            let id = null;
            if (this.props.defaultValues) {
                id = this.props.defaultValues.id;
            }

            this.userService.checkIfEmailIsInUse(email, id)
                .then((response: Response) => {
                    response.json().then((emailInUse) => {
                        if (emailInUse) {
                            this.setState(
                                {
                                    emailValidating: false,
                                    formErrors: Object.assign({ ...this.state.formErrors }, { email: 'The provided email is already in use' })
                                },
                                () => { this.formApi.setTouched('email', true); }
                            );
                        } else {
                            this.setState(
                                {
                                    emailValidating: false,
                                    formErrors: Object.assign({ ...this.state.formErrors }, { email: undefined })
                                },
                                () => { 
                                    this.formApi.setTouched('email', true); 
                                    this.formApi.setError('email', '');
                                }
                            );
                        }
                    });
                })
                .catch(() => {
                    this.setState({ formErrors: Object.assign({ ...this.state.formErrors }, { email: 'An error occurred while checking email availability' }) }, () => { this.formApi.setTouched('email', true); });
                });
        }
    }
    // end of validation stuff

    private submit(formApi: any, e: any) {
        formApi.submitForm(e);
    }

    private toggleMember(index: number) {
        var orgs = this.state.confirmedOrgs;
        orgs[index].isMember = !orgs[index].isMember;
        this.setState({
            confirmedOrgs: orgs
        });
    }

    private toggleFormer(index: number) {
        var orgs = this.state.confirmedOrgs;
        orgs[index].isFormer = !orgs[index].isFormer;
        this.setState({
            confirmedOrgs: orgs
        });
    }

    private toggleCandidate(index: number) {
        var orgs = this.state.confirmedOrgs;
        orgs[index].isCandidate = !orgs[index].isCandidate;
        this.setState({
            confirmedOrgs: orgs
        });
    }

    public render() {
        const { userRoleOptions, userPermissionsOptions, selectedOrganizationId, teamTypeahead, confirmedTeams, orgTypeahead, confirmedOrgs, managerTypeahead, confirmedManager, canSubmit, formErrors } = this.state;

        const organizationOptions = !this.props.organizations ? [] : this.props.organizations.map((organization) => {
            return {
                label: organization.name,
                value: organization.id
            };
        });

        const languageOptions = !this.props.languages ? [] : this.props.languages.map((language) => {
            return {
                label: language.name,
                value: language.id
            };
        });

        return (
            <div>
                <Form
                    defaultValues={this.props.defaultValues}
                    formDidUpdate={this.formDidUpdate}
                    onSubmit={submittedValues => this.handleFormSubmit(submittedValues)}
                    validateError={this.validateErrors}
                    validateSuccess={this.validateSuccess}
                    getApi={this.setFormApi}
                >
                    {formApi => (
                        <form onSubmit={(e) => this.submit(formApi, e)} id="entityForm">
                            <div className="row">
                                <div className="col-sm-6">
                                    <div className="form-group">
                                        <label htmlFor="firstName">First Name *</label>
                                        <Text className="form-control" field="firstName" id="firstName" />
                                        {formErrors.firstName && <span className="help-block error-text">{formErrors.firstName}</span>}
                                    </div>
                                </div>
                                <div className="col-sm-6">
                                    <div className="form-group">
                                        <label htmlFor="lastName">Last Name *</label>
                                        <Text className="form-control" field="lastName" id="lastName" />
                                        {formErrors.lastName && <span className="help-block error-text">{formErrors.lastName}</span>}
                                    </div>
                                </div>
                            </div>
                            <div className="form-group">
                                <label htmlFor="email">Email *</label>
                                <Text type="email" className="form-control" field="email" id="email" onKeyUp={this.checkEmailAddress} />
                                {formErrors.email && <span className="help-block error-text">{formErrors.email}</span>}
                            </div>
                            <div className="form-group">
                                <label htmlFor="email">External ID</label>
                                <Text type="text" className="form-control" field="externalID" id="externalID" />
                            </div>
                            <div className="form-group">
                                <label htmlFor="languageID">Language *</label>
                                <Select className="form-control" field="languageID" id="languageID" options={languageOptions} />
                                {formErrors.languageID && <span className="help-block error-text">{formErrors.languageID}</span>}
                            </div>
                            {['superAdmin', 'siteAdmin', 'ponderaAssociate'].includes(this.userRole) && <div className="form-group">
                                <label htmlFor="organizationID">Organization *</label>
                                <Select className="form-control" field="organizationID" id="organizationID" options={organizationOptions} />
                                {formErrors.organizationID && <span className="help-block error-text">{formErrors.organizationID}</span>}
                            </div>}
                            <div>
                            {['superAdmin', 'siteAdmin', 'organizationAdmin'].includes(this.userRole) && <div>
                                {['superAdmin', 'siteAdmin'].includes(this.userRole) && <div style={{paddingLeft: '25px'}} className="form-group">
                                    <label>Associated Organizations</label>
                                    <InputGroup>
                                        <AsyncTypeahead
                                            ref={(typeahead: any) => this.orgTypeahead = typeahead}
                                            {...orgTypeahead}
                                            minLength={2}
                                            onSearch={this.handleOrganizationSearch}
                                            onFocus={this.handleOrgOnFocus}
                                            onChange={this.orgTypeaheadOnChange}
                                            placeholder="Search for an organization"
                                            labelKey={(option) => `${option.name}`}
                                        />
                                        <InputGroup.Button>
                                            <button onClick={this.addOrg} className="btn btn-default">Add</button>
                                        </InputGroup.Button>
                                    </InputGroup>
                                </div>}
                                {['organizationAdmin'].includes(this.userRole) &&  <div className="form-group"><label>Organization Settings</label></div>}
                                {(confirmedOrgs && confirmedOrgs.length > 0) && <div style={{paddingLeft: '25px'}}>
                                        <table style={{paddingLeft: '25px'}} className="table table-striped">
                                            <thead>
                                                <tr>
                                                    <th>Name</th>
                                                    <th>Is Member</th>
                                                    <th>Is Candidate</th>
                                                    <th>Is Former Employee</th>
                                                    <th />
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {confirmedOrgs.map((org, index) => (
                                                    <tr key={`org-${org.id}`}>
                                                        <td>
                                                            {org.name}
                                                        </td>
                                                        <td>
                                                            <input type="checkbox" checked={org.isMember} onClick={() => this.toggleMember(index)} />
                                                        </td>
                                                        <td>
                                                            <input type="checkbox" checked={org.isCandidate} onClick={() => this.toggleCandidate(index)} />
                                                        </td>
                                                        <td>
                                                            <input type="checkbox" checked={org.isFormer} onClick={() => this.toggleFormer(index)} />
                                                        </td>
                                                        <td>
                                                            {['superAdmin', 'siteAdmin'].includes(this.userRole) && <span onClick={this.removeOrgBinder(org.id)} className="glyphicon glyphicon-trash" />}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>}
                            </div>}</div>
                            <div className="form-group">
                                <label htmlFor="title">Title</label>
                                <Text type="title" className="form-control" field="title" id="title" />
                            </div>
                            <div className="form-group">
                                <label htmlFor="resultsArePrivate">Treat Results as Private?</label>
                                <Checkbox className="checkbox" field="resultsArePrivate" />
                            </div>
                            {selectedOrganizationId &&
                                <div>
                                    <div className="form-group">
                                        <label>Manager</label>
                                        <AsyncTypeahead
                                            {...managerTypeahead}
                                            minLength={0}
                                            defaultInputValue={confirmedManager ? (confirmedManager.lastName + ', ' + confirmedManager.firstName) : undefined}
                                            onSearch={this.handleManagerSearch}
                                            onFocus={this.handleManagerOnFocus}
                                            onChange={this.managerTypeaheadOnChange}
                                            placeholder="Search for manager"
                                            labelKey={(option) => `${option.lastName}, ${option.firstName}`}
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label>Teams</label>
                                        <InputGroup>
                                            <AsyncTypeahead
                                                ref={(typeahead: any) => this.teamTypeahead = typeahead}
                                                {...teamTypeahead}
                                                minLength={0}
                                                onSearch={this.handleTeamSearch}
                                                onFocus={this.handleTeamOnFocus}
                                                onChange={this.teamTypeaheadOnChange}
                                                placeholder="Search for a team"
                                                labelKey={(option) => `${option.name}`}
                                            />
                                            <InputGroup.Button>
                                                <button onClick={this.addTeam} className="btn btn-default">Add</button>
                                            </InputGroup.Button>
                                        </InputGroup>
                                    </div>
                                    {(confirmedTeams && confirmedTeams.length > 0) &&
                                        <table className="table table-striped">
                                            <thead>
                                                <tr>
                                                    <th>Name</th>
                                                    <th>Is Member?</th>
                                                    <th>Is Manager?</th>
                                                    <th />
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {confirmedTeams.map((userteam, index) => (
                                                    <tr key={`team-${userteam.teamID}`}>
                                                        <td>
                                                            {userteam.team!.name}
                                                        </td>
                                                        <td>
                                                            <input type="checkbox" checked={userteam.isMember} onChange={this.handleIsMemberChangeBinder(userteam.team!.id)} />
                                                        </td>
                                                        <td>
                                                            <input type="checkbox" checked={userteam.isManager} onChange={this.handleIsManagerChangeBinder(userteam.team!.id)} />
                                                        </td>
                                                        <td>
                                                            <span onClick={this.removeTeamBinder(userteam.team!.id)} className="glyphicon glyphicon-trash" />
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    }
                                </div>
                            }
                            {userRoleOptions.length > 1 && <div className="form-group">
                                <label htmlFor="userRole"><span onClick={this.showUserRoleModal} className="glyphicon glyphicon-info-sign icon-buttonpco" />&nbsp;&nbsp;Role *</label>
                                <Select className="form-control" field="userRole" id="userRole" options={userRoleOptions} />
                                {formErrors.userRole && <span className="help-block error-text">{formErrors.userRole}</span>}
                            </div>}
                            {this.userRole !== 'user' && this.userRole !== 'manager' && <div>
                                <hr />
                                <div className="form-group">
                                    <label>Additional Permissions</label>
                                </div>
                                <div className="row">
                                    {
                                        userPermissionsOptions.map((item, index) => {
                                            return (
                                                <div key={`permission-index-${index}`} className="col-sm-4 col-md-3">
                                                    <div className="checkbox">
                                                        <label>
                                                            <input type="checkbox" checked={item.isChecked} onChange={this.permissionCheckboxUpdatedBinder(item.value)} /> {item.label}
                                                        </label>
                                                    </div>
                                                </div>);
                                        })
                                    }
                                </div>
                            </div>}

                            <hr />
                            {['superAdmin', 'siteAdmin'].includes(this.userRole) && <SecondaryReportOrgUserForm notificationService={this.props.notificationService} userId={this.props.defaultValues.id} orgId={this.props.defaultValues.organizationID} />}
                            <hr />
                            {['superAdmin', 'siteAdmin'].includes(this.userRole) && <SurveyReportTypeUserForm notificationService={this.props.notificationService} userId={this.props.defaultValues.id} orgId={this.props.defaultValues.organizationID} />}
                            <hr />

                            <button type="submit" className="btn btn-primary" disabled={!canSubmit}>Save</button>
                        </form>
                    )
                    }
                </Form>
                <PonderaModal title="User Role Info" content={this.state.userRoleHelpModalContent} show={this.state.userRoleHelpModalVisible} onHide={this.hideUserRoleModal} />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/user/UserForm.tsx